import { render, staticRenderFns } from "./EnsureCmsSsaOpps.vue?vue&type=template&id=00a04f7a&lang=pug"
import script from "./EnsureCmsSsaOpps.vue?vue&type=script&lang=js"
export * from "./EnsureCmsSsaOpps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default,DateTimeInput: require('/home/docker/code/frontend/components/DateTimeInput.vue').default})
